import { Editor } from '@tiptap/core';
import { SeparatorHorizontalIcon } from 'lucide-react';
import React from 'react';

import { Button } from '@/ui/Button';
import { cn } from '@/utils';

interface HorizontalRuleMenuItemProps {
	editor: Editor | null;
}

const HorizontalRuleMenuItem = (props: HorizontalRuleMenuItemProps) => {
	const { editor } = props;

	if (!editor) {
		return null;
	}

	return (
		<Button
			onClick={() => editor.chain().focus().setHorizontalRule().run()}
			disabled={!editor.can().chain().focus().setHorizontalRule().run()}
			className={cn('w-6 h-7 text-brand-gray-2 [&>svg]:size-6 [&>svg]:reset p-0 [&>svg]:left-[0px]', {
				'text-brand-blue': editor.isActive('horizontalRule'),
			})}
			size="icon"
			icon="left"
			variant="tetriary"
		>
			<SeparatorHorizontalIcon size={16} />
		</Button>
	);
};

export { HorizontalRuleMenuItem };
